module.exports = {
  path: 'login',
  getComponent(nextState, cb) {
    require.ensure([], (require) => {
      cb(null, require('./components/Login').default || require('./components/Login'));
    }, 'login');
  }
};



// WEBPACK FOOTER //
// ./routes/login/index.js